import { ApiError, type SessionState } from "../api/client";

/**
 * Die vier Lagen, in denen sich die Anmeldung befinden kann — und die eine, in
 * der man es noch nicht weiß.
 *
 * Serverseitig sind „war nie angemeldet" und „abgelaufen" **derselbe** Zustand:
 * Die App-Sitzung ist die ERP-Sitzung, und dort gibt es den Unterschied nicht.
 * Ob „Ihre Sitzung ist abgelaufen" angebracht ist, weiß allein der Browser, denn
 * nur er kennt seinen vorigen Stand. Deshalb ein einziger Fehlercode vom Server
 * (`not_signed_in`) und die Unterscheidung hier.
 *
 * Der wichtigste Unterschied ist der zwischen `expired` und `unavailable`: „Ihre
 * Sitzung ist abgelaufen" zu sagen, während in Wahrheit das SilverERP steht,
 * schickt den Menschen in eine Anmeldung, die nicht gelingen kann — und lässt
 * ihn den Grund suchen, den die Anwendung kennt.
 */
export type SessionStatus = "unknown" | "signed_in" | "expired" | "signed_out" | "unavailable";

export interface SessionLookup {
  state: SessionState | null;
  error: ApiError | null;
  /** Ob dieser Browser vorher schon eine Sitzung gesehen hat. */
  wasSignedIn: boolean;
}

export function sessionStatus({ state, error, wasSignedIn }: SessionLookup): SessionStatus {
  if (error === null) {
    return state === null ? "unknown" : "signed_in";
  }

  if (error.code !== "not_signed_in") {
    return "unavailable";
  }

  return wasSignedIn ? "expired" : "signed_out";
}
